import React, { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/branches/BranchesAction";
import {
  DeleteButton,
  ExportButton,
  FormButton,
  copy,
  deletionAlert,
  exportToExcel,
  exportToPDF,
  getAuthorities,
  noRecordsAlert,
  print,
  redirectToPages,
  resultAlert
} from "../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { BranchesFilter } from "./branches-filter/BranchesFilter";
import { BranchesTable } from "./branches-table/BranchesTable";
import { useBranchesUIContext } from "./BranchesUIContext";

export function BranchesCard() {
  // Branches UI Context
  const branchesUIContext = useBranchesUIContext();
  const branchesUIProps = useMemo(() => {
    return {
      ids: branchesUIContext.ids,
      setIds: branchesUIContext.setIds,
      queryParams: branchesUIContext.queryParams,
      openNewBranchPage: branchesUIContext.openNewBranchPage,
    };
  }, [branchesUIContext]);
    
  // Getting curret state of Branch list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.branches }),
    shallowEqual
  );
  const { actionsLoading, isSuccess, type, authorities } = currentState;

  // Authority Parameters
  const { isExportationAuthorized, isAdditionAuthorized, isDeletionAuthorized } = getAuthorities(authorities);

  // Branches Redux state
  const dispatch = useDispatch();

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  /** Belli Bir Branş Listesini Excele Aktarır */
  const exportBranchesToExcel = () => {
    dispatch(actions.getAllBranches(branchesUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const rows = [];
      const widths = [30];
      const columns = ["Adı"];
      entities.forEach(entity => rows.push([entity.name]));
      const filename = "Branş Listesi"
      exportToExcel({ columns, rows, widths, filename });
    });
  }

  /** Belli Bir Branş Listesini PDF e Aktarır */
  const exportBranchesToPDF = () => {
    dispatch(actions.getAllBranches(branchesUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const views = [ 
        {
          header: "Adı",
          rows: entities.map(entity => entity.name)
        }
      ];
  
      const filename = "Branş Listesi";
      exportToPDF(views, filename);
    });
  }

  /** Belli Bir Branş Listesini Yazdırma Penceresini Açar */
  const printBranches = () => {
    dispatch(actions.getAllBranches(branchesUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const data = [];    
      const header = "Branş Listesi";
      const properties = ["Adı"];

      entities.forEach(entity => {
        data.push({
          "Adı": entity.name
        });
      });

      print({ data, properties, header });
    });
  }

  /** Belli Bir Branş Listesini Panoya Kopyalar */
  const copyBranches = () => {
    dispatch(actions.getAllBranches(branchesUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const rows = [];
      const header = "Branş Listesi";
      const columns = ["Adı"];
      entities.forEach(entity => rows.push([entity.name]));
      copy({ header, columns, rows });
    });
  }

  /** Belli Bir Branş Listesini Siler */
  const deleteBranches = (ids) => {
    if (typeof ids === 'string') ids = ids.split(",");
  
    if (ids.length < 1) {
      noRecordsAlert();
      return;
    }
  
    deletionAlert().then(result => {
      if (result.isConfirmed) dispatch(actions.deleteBranches(ids)).then(result => onResult(result));
    });
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);

    if (isSuccess) {
      setTimeout(() => {
        // clear selections list
        branchesUIProps.setIds([]);
        // refresh list after deletion
        dispatch(actions.getBranches(branchesUIProps.queryParams));        
      }, 2500);
    }
  };
  
  const title = <>Branş Listesi{branchesUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{branchesUIProps.ids.length}</span>]</> :
                   ""}
                </>;

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        {
          (isExportationAuthorized || isAdditionAuthorized || isDeletionAuthorized) &&
          <CardHeaderToolbar>
            {
              isExportationAuthorized &&
              <ExportButton
                exportToExcel={exportBranchesToExcel}
                exportToPDF={exportBranchesToPDF}
                print={printBranches}
                copy={copyBranches}
              />
            }
            {
              isAdditionAuthorized && 
              <FormButton 
                path="Navigation/Plus"
                title="Yeni Branş"
                method={branchesUIProps.openNewBranchPage}
              />
            }
            {
              isDeletionAuthorized && 
              <DeleteButton
                title="Seçilenleri Sil"
                method={() => deleteBranches(branchesUIProps.ids)}
              />
            }
          </CardHeaderToolbar>
        }        
      </CardHeader>
      <CardBody>
        <BranchesFilter />
        <BranchesTable
          deleteBranches={deleteBranches}
        />
      </CardBody>
    </Card>
  );
}